import React, {Component, Children, PropTypes} from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
  user: state.user,
})

class Restricted extends Component{

  static propTypes = {
    by: PropTypes.string.isRequired,
    except: PropTypes.array.isRequired
  }

  constructor(props){
    super(props)
  }

  render(){
    const {rolesPerSchool} = this.props.user
    const schoolId = localStorage.getItem('schoolId')
    const role = rolesPerSchool[schoolId]
    const {by, except} = this.props

    let children;
    if (Array.isArray(this.props.children)) {
      children = this.props.children[0];
    } else {
      children = this.props.children;
    }

    if(by == 'disable' && except.indexOf(role) == -1){
      children = React.cloneElement(children, { disabled: true });
      return Children.only(children)
    }

    if(by == 'hide' && except.indexOf(role) == -1){
      return <span />
    }

    return children;

  }
}


export default connect(mapStateToProps)(Restricted)



// WEBPACK FOOTER //
// ./src/containers/Restricted/index.js